<template>
  <div class="gs-checkout-builder-step gs-checkout-passwords-step">
    <div class="gs-checkout-passwords-step__switch-row">
      <div>
        <h3>{{ $t('frontend_checkout_links_step6_collect') }}</h3>
        <p>Enable account credentials only for offers that require buyer access after purchase.</p>
      </div>
      <gd-toggle
        v-model="localModel.has_password_fields"
        :value="localModel.has_password_fields"
        :aria-label="$t('frontend_checkout_links_step6_collect')"
      />
    </div>

    <template v-if="localModel.has_password_fields">
      <section class="gs-checkout-passwords-step__table-card">
        <div class="gs-checkout-passwords-step__table-head">
          <span>Price point</span>
          <span>{{ $t('frontend_ask_user_name') }}</span>
          <span>{{ $t('frontend_ask_for_pass') }}</span>
        </div>

        <div class="gs-checkout-passwords-step__rows">
          <div v-for="pricePoint in pricepointsForProjectionsFiltered" :key="pricePoint.id"
            class="gs-checkout-passwords-step__row">
              <strong>{{ pricePoint.name }}</strong>
              <div>
                <gd-toggle v-model="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].ask_username"
                  :value="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].ask_username"
                  :aria-label="`Ask for username for ${pricePoint.name}`" />
              </div>
              <div>
                <gd-toggle v-model="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].ask_for_password"
                  :value="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].ask_for_password"
                  :aria-label="`Ask for password for ${pricePoint.name}`" />
              </div>
          </div>
        </div>
      </section>

      <section v-if="model.is_onestep != 1 && movePasswordFieldSwith" class="gs-checkout-passwords-step__placement">
        <div class="gs-checkout-passwords-step__placement-copy">
          <h3>Password step placement</h3>
          <p>Choose where password collection appears in the multi-step checkout.</p>
        </div>
        <div class="gs-checkout-passwords-step__placement-grid">
          <div v-for="askForPasswordType in askForPasswordType" :key="askForPasswordType.id">
            <checkout-radio-button v-model="askPasswordValue" :option="askForPasswordType"
              @onUpdateOption="changeAskPasswordType" />
          </div>
        </div>
      </section>
    </template>

    <div v-else class="gs-checkout-passwords-step__empty">
      Password and username fields will not appear on this checkout.
    </div>
  </div>
</template>

<script>
import CheckoutRadioButton from '../../../../components/CheckoutRadioButton.vue';

export default {
  name: 'PasswordsStep',
  components: {
    CheckoutRadioButton,
  },
  props: {
    model: {
      required: true,
    },
    pricepointTabs: {
      required: true,
    },
    selectPricePoint: {
      required: true,
    },
    pricepointsForProjections: {
      required: true,
    },
    projectionsPricePointsTab: {
      required: true,
    },
    handleProjectionPricePointTabChange: {
      required: true,
    },
    selectedMultiStepType: {
      required: true,
    },
  },

  data() {
    return {
      askPasswordValue: 1,
      test: false,
      localModel: this.model,
      pricePointTabsEnabled: [],
      skip_field_arr: [],
      pricepointsForProjectionsFiltered: [],
      // ask_for_password_select: 0,
      ask_for_password_select: 1,
      projectionsPPointsTab: this.projectionsPricePointsTab,
    };
  },
  computed: {
    movePasswordFieldSwith() {
      let hasPasswordEnable = false;
      for (let i = 0; i < this.localModel.skip_field_arr.length; i++) {
        if (this.localModel.skip_field_arr[i].ask_for_password === true) {
          hasPasswordEnable = true;
        }
      }
      return hasPasswordEnable;
    },

    askForPasswordType() {
      if (this.selectedMultiStepType == 1) {
        return [
          {
            id: 1,
            svg: ['ContactAndPassword', 'Billing', 'Payment'],
            label: this.$t('frontend_checkout_links_step6_collect_pass_at_start')
          },
          {
            id: 0,
            svg: ['Contact', 'Billing', 'Password', 'Payment'],
            label: this.$t('frontend_checkout_links_step6_collect_pass_at_end')
          },
        ];
      }
      if (this.selectedMultiStepType == 2) {
        return [
          {
            id: 1,
            svg: ['EmailAndPassword', 'Contact', 'Billing', 'Payment'],
            label: this.$t('frontend_checkout_links_step6_collect_pass_at_start')
          },
          {
            id: 0,
            svg: ['Email', 'Contact', 'Billing', 'Password', 'Payment'],
            label: this.$t('frontend_checkout_links_step6_collect_pass_at_end')
          },
        ];
      }

      return [
        {
          id: 1,
          svg: ['EmailAndPassword', 'Order'],
          label: this.$t('frontend_checkout_links_step6_collect_pass_at_start')
        },
        {
          id: 0,
          svg: ['Email', 'OrderAndPassword'],
          label: this.$t('frontend_checkout_links_step6_collect_pass_at_end')
        },
      ];
    },
  },
  watch: {
    localModel: {
      deep: true,
      handler(){
        this.$emit('updateModel', this.localModel);
      },
    },
  },

  async created() {
    if (this.localModel.checkout_link_page_options.move_password_to_last_step) {
      this.askPasswordValue = 0;
    }

    const enabledPricePoints = this.selectPricePoint.filter((pricePoint) => {
      return pricePoint.enabled;
    });

    const enabledPricePointIdArr = enabledPricePoints.map((point) => {
      return point.id;
    });

    for (let i = 0; i < enabledPricePoints.length; i++) {
      this.pricePointTabsEnabled.push({
        title: enabledPricePoints[i].name,
        value: `price_point_${enabledPricePoints[i].id}`,
      });
    }

    for (let i = 0; i < this.pricepointsForProjections.length; i++) {
      if (enabledPricePointIdArr.indexOf(this.pricepointsForProjections[i].id) != -1) {
        this.pricepointsForProjectionsFiltered.push(
          this.pricepointsForProjections[i]
        );
      }
    }

    if (this.pricepointsForProjectionsFiltered.length)
      this.projectionsPPointsTab = `price_point_${this.pricepointsForProjectionsFiltered[0].id}`;
  },

  methods: {
    changeAskPasswordType(value) {
      this.askPasswordValue = value;
      this.localModel.checkout_link_page_options.move_password_to_last_step = value != 1
    },

    localModelPricePointIndex(pricePointId) {
      return this.localModel.skip_field_arr.findIndex(
        (pricepoint) => pricepoint.id == pricePointId
      );
    },

    validate() {
      const isValid = true;
      this.$emit('on-validate', isValid);
      return isValid;
    },
  },
};
</script>

<style scoped>
.gs-checkout-passwords-step {
  display: grid;
  gap: 18px;
}

.gs-checkout-passwords-step__switch-row,
.gs-checkout-passwords-step__table-card,
.gs-checkout-passwords-step__placement,
.gs-checkout-passwords-step__empty {
  padding: 20px;
  background: #fff;
  border: 1px solid var(--gs-border, #e2e8f0);
  border-radius: 12px;
}

.gs-checkout-passwords-step__switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.gs-checkout-passwords-step h3,
.gs-checkout-passwords-step p {
  margin: 0;
}

.gs-checkout-passwords-step h3 {
  color: var(--gs-foreground, #182230);
  font-size: 14px;
  font-weight: 800;
}

.gs-checkout-passwords-step p,
.gs-checkout-passwords-step__empty {
  color: var(--gs-muted-foreground, #667085);
  font-size: 12px;
  line-height: 1.5;
}

.gs-checkout-passwords-step p {
  margin-top: 4px;
}

.gs-checkout-passwords-step__table-head,
.gs-checkout-passwords-step__row {
  display: grid;
  align-items: center;
  grid-template-columns: minmax(220px, 1fr) 160px 160px;
  gap: 16px;
}

.gs-checkout-passwords-step__table-head {
  padding: 0 8px 12px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .05em;
  text-transform: uppercase;
}

.gs-checkout-passwords-step__table-head span:not(:first-child),
.gs-checkout-passwords-step__row > div {
  text-align: center;
}

.gs-checkout-passwords-step__rows {
  max-height: 320px;
  overflow-y: auto;
  border-top: 1px solid var(--gs-border, #e2e8f0);
}

.gs-checkout-passwords-step__row {
  min-height: 56px;
  padding: 9px 8px;
  border-bottom: 1px solid var(--gs-border, #e2e8f0);
}

.gs-checkout-passwords-step__row strong {
  color: var(--gs-foreground, #182230);
  font-size: 12px;
  font-weight: 700;
}

.gs-checkout-passwords-step__placement-copy {
  margin-bottom: 16px;
}

.gs-checkout-passwords-step__placement-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.gs-checkout-passwords-step__empty {
  background: #f8fafc;
}
</style>
